import { render } from "./DocumentLink.vue?vue&type=template&id=611b70f5&scoped=true"
import script from "./DocumentLink.vue?vue&type=script&lang=js"
export * from "./DocumentLink.vue?vue&type=script&lang=js"

import "./DocumentLink.vue?vue&type=style&index=0&id=611b70f5&scoped=true&language=scss&lang=css"
script.render = render
script.__scopeId = "data-v-611b70f5"

export default script